import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { Section } from "~/providers/section-provider";
import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useSection } from "~/hooks/use-section";
import { useSectionManager } from "~/managers/use-section-manager";

export const Route = createFileRoute("/_main/settings/_layout/sections")({
  component: Sections,
});

function Sections() {
  const { t } = useTranslation("common");
  const { sections } = useSection();
  const { openSectionDialog } = useSectionManager();
  const columns: ColumnDef<Section>[] = [
    {
      id: t("name"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: section }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html: highlightText(section.name, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
    {
      id: t("Section.position"),
      accessorKey: "position",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Section.position")} />
      ),
      cell: ({ row: { original: section }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html:
                highlightText(section.position.toString(), globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
  ];
  return (
    <>
      <SettingsHeader
        title={t("sections")}
        buttonLabel={capitalize(t("new_section"))}
        buttonAction={async () => {
          await openSectionDialog();
        }}
      />

      <DataTable
        defaultSorting={[{ id: t("Section.position"), desc: false }]}
        columns={columns}
        data={sections}
        onSelect={openSectionDialog}
      />
    </>
  );
}
